(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nara-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nara-tabs')) {
    customElements.define(
      'nara-tabs',
      class NaraTabs extends HTMLElement {
        connectedCallback() {
          this.buttons = this.querySelectorAll('[role="tab"]');
          this.panels = this.querySelectorAll('[role="tabpanel"]');
          this.buttons.forEach((button) => {
            button.addEventListener('click', () => this.select(button));
            button.addEventListener('keydown', (event) => this.onKey(event, button));
          });
        }

        select(button) {
          const id = button.getAttribute('aria-controls');
          this.buttons.forEach((item) => {
            const selected = item === button;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.tabIndex = selected ? 0 : -1;
          });
          this.panels.forEach((panel) => {
            panel.hidden = panel.id !== id;
          });
        }

        onKey(event, button) {
          const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          const items = Array.from(this.buttons);
          const index = items.indexOf(button);
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % items.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + items.length) % items.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = items.length - 1;
          items[next].focus();
          this.select(items[next]);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
